"use client";

import { HorizontalGrid, ListContainer, ListItem } from "@/components/list/dynamic-list";
import { TChaptersList } from "@/types/types";

type ContinueWatchingListProps = {
  nextChapters: TChaptersList;
};

export default function ContinueWatchingList({ nextChapters }: ContinueWatchingListProps) {
  return (
    <ListContainer
      title="Continue watching"
      variant="transparent"
      isEmpty={nextChapters.length === 0}
      emptyMessage="You have no chapters to watch"
    >
      <HorizontalGrid
        items={nextChapters}
        renderItem={(chapter) => (
          <ListItem
            title={chapter.title || ""}
            subtitle={chapter.section.title}
            thumbnailUrl={chapter.chapterVideo?.thumbnailUrl || ""}
            href={`/course/${chapter.section.course.slug}/chapter/${chapter.slug}`}
            variant="grid"
          />
        )}
      />
    </ListContainer>
  );
}
